import { Injectable } from '@angular/core';
import {
  ApplicationConfig,
  DashboardResponse,
  MyTripAem,
  OauthAEMConfig,
  UserSessionService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MyTripEndpointKeys } from '../models/enums/my-trip.enums';
import { MostUpcomingTrip } from '../models/interface/upcoming-trip.interface';
import { MyTripsService } from '../services/my-trips.service';
import { MyTripBaseFacadeService } from './my-trip-base.facade.ts.service';
import { MyTripFacadeHelper } from './my-trip.facade.helper';

@Injectable({
  providedIn: 'root'
})
export class MyTripFacade extends MyTripBaseFacadeService {
  constructor(
    private tripsService: MyTripsService,
    private readonly userSession: UserSessionService,
    private readonly facadeHelper: MyTripFacadeHelper,
    private appConfig: ApplicationConfig
  ) {
    super();
  }

  init(headerContent?: MyTripAem, onloadCall = false): void {
    if (this.isValidHeaderContent(headerContent)) {
      this.myTripStaticContent.set(headerContent as MyTripAem);
      this.loadWidget(onloadCall);
    } else if (!this.staticContent().id) {
      this.loadFromTripsService(onloadCall);
    } else {
      this.loadWidget(onloadCall);
    }
  }

  private isValidHeaderContent(content?: MyTripAem): boolean {
    return !!(content?.id && content?.tripDetails && content?.errors?.length);
  }

  private loadFromTripsService(onloadCall: boolean): void {
    this.tripsService
      .getPageContent()
      .pipe(
        catchError(() => {
          setTimeout(() => this.showAlert.set(true), 100);
          return of({} as MyTripAem);
        })
      )
      .subscribe((content: MyTripAem) => {
        if (content.id) {
          this.myTripStaticContent.set(content);
          this.loadWidget(onloadCall);
        }
      });
  }

  checkLogin(onloadCall: boolean | undefined): void {
    this.userSession.getUserSession().subscribe((data: DashboardResponse) => {
      this.userSessionData.set(data);
      if (Object.keys(data).length > 0 && data.loggedIn) {
        this.callUpcomingTripsApi(data, onloadCall);
      }
    });
  }

  loadWidget(onloadCall: boolean): void {
    this.userData
      .getAuthConfigContent()
      .subscribe((authConfig: OauthAEMConfig) => {
        this.tripsService.getURL(MyTripEndpointKeys.FIND_PNR);
        this.displayFindTripLink.set(true);
        this.displayErrorMessage.set(false);
        this.facadeHelper.updateSearchAndAncillaryContent(
          this.staticContent(),
          this.tripDetails(),
          authConfig.NAME_LENGTH_CONFIG
        );
        const userData = this.userSessionData();
        if (userData === null) {
          this.checkLogin(onloadCall);
        } else if (userData.loggedIn) {
          if (Object.keys(this.tripDetails()).length) {
            this.displayUpcomingTripDetails(this.tripDetails());
          } else {
            this.callUpcomingTripsApi(userData);
          }
        }
      });
  }

  callUpcomingTripsApi(
    dashBoardResponse: DashboardResponse,
    onloadCall = false
  ): void {
    this.spinner.set(true);
    this.facadeHelper.callUpcomingTripsApi(
      dashBoardResponse,
      this.mostRecentTripsData,
      this.displayErrorMessage,
      this.showMytrip,
      (response) => {
        this.displayUpcomingTripDetails(response);
        this.spinner.set(false);
      },
      () => {
        this.spinner.set(false);
      },
      onloadCall
    );
  }

  tripDetails = (): MostUpcomingTrip => this.mostRecentTripsData();
  staticContent = (): MyTripAem => this.myTripStaticContent();

  displayFindTrip = (flag: boolean): void => {
    this.displayErrorMessage.set(false);
    this.displayTripDetails.set(!flag);
    this.displayFindTripLink.set(!flag);
  };

  displayUpcomingTripDetails(response: MostUpcomingTrip): void {
    this.facadeHelper.displayUpcomingTripDetails(
      response,
      this.staticContent(),
      this.displayFindTripLink,
      this.displayTripDetails,
      this.adaptedTripDetails
    );
    this.spinner.set(false);
  }
}
